const API_URL = process.env.REACT_APP_STRAPI_URL;


export async function fetchGlobalLayout() {
    const response = await fetch(`${API_URL}/api/global-layout?populate=all`);
    const data = await response.json();
    return data.data;
}

export async function fetchPageView(slug) {
    if (slug === '') {
        slug = "home";
    }
    let url = `${API_URL}/api/page-views?populate=all&filters[slug]=` + slug;
    // console.log(url);
    const response = await fetch(url);
    const data = await response.json();
    // console.log(JSON.stringify(data));
    return data.data[0];
}
